import * as Yup from 'yup'
import * as FormConst from './FormConst'

export const dressCodeOptions = [
    {label: "Business Casual", value: "Business Casual"},
    {label: "Casual", value: "Casual"},
    {label: "Casual Elegance", value: "Casual Elegance"},
    {label: "Formal", value: "Formal"},
    {label: "Jacket Required", value: "Jacket Required"},
    {label: "Resort Casual", value: "Resort Casual"},
    {label: "Resort Elegant", value: "Resort Elegant"},
    {label: "Resort Formal", value: "Resort Formal"}
]
export const locationOptions = [
    {label: "", value: ""},
    {label: "Beachfront", value: "Beachfront"},
    {label: "Executive Lounge Level", value: "Executive Lounge Level"},
    {label: "Lobby", value: "Lobby"},
    {label: "Lobby Adjacent", value: "Lobby Adjacent"},
    {label: "Floor", value: "Floor"},
    {label: "Rooftop", value: "Rooftop"},
    {label: "Other", value: "Other"}
]
//Table Headers
export const diningHeaders = ['Dining Name', 'Location', 'Cuisine', 'Dress Code', "Phone No", "Email", "Edit", "Delete"]
export const dayHeaders = ['','Monday', 'Tuesday', 'Wednesday', 'Thursday', "Friday", "Saturday", "Sunday"]

export const validationSchemaHotelDiningContent = Yup.object().shape({
    //Relevant to all variation validation
    restaurantName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.DESTINATION_NAME_MAX_LENGTH, `Up to ${FormConst.DESTINATION_NAME_MAX_LENGTH} characters allowed`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
    locationToHotel: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
    //Relevant to Non Hotel Content
    distance: Yup.number().when("locationToHotel", {
        is: FormConst.VALUE_NEARBY,
        then: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO)
            .max(FormConst.MAX_DESTINATION_DISTANCE, FormConst.VALIDATION_ERROR_DESTINATIONS_DISTANCE)
    }),
    direction: Yup.string().when("locationToHotel", {
        is: FormConst.VALUE_NEARBY,
        then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
    }),
    openingTime: Yup.string().nullable().test('openingTime', 
        function(val) {
            if (((canAccessHotelDining.value == 'true' && locationToHotel[1].value != FormConst.VALUE_ONSITE) || canAccessHotelDining.value == 'false') && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true;
        }
    ),
    closingTime: Yup.string().nullable().test('closingTime', 
        function(val) {
            if (((canAccessHotelDining.value == 'true' && locationToHotel[1].value != FormConst.VALUE_ONSITE) || canAccessHotelDining.value == 'false') && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true;
        }
    ),
    speciality: Yup.string().test('specialty', 
        function(val) {
            if (((canAccessHotelDining.value == 'true' && locationToHotel[1].value != FormConst.VALUE_ONSITE) || canAccessHotelDining.value == 'false') && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true;
        }
    ),
    //Relevant to only hotel content
    shortDescription: Yup.string().max(FormConst.MAX_LENGTH_SHORT_DESCRIPTION, `Maximum ${FormConst.MAX_LENGTH_SHORT_DESCRIPTION} characters`)
        .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS).test('shortDescription', 
            function(val) {
                if (canAccessHotelDining.value == 'true' && locationToHotel[1].value == FormConst.VALUE_ONSITE && !val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                }
                return true;
            }
        ),
    phoneCountryCode: Yup.string()
        .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
        .length(2, `Must be 2 digits`).test('detailedLocation', 
            function(val) {
                if ((!!this.parent.phoneAreaCode || !!this.parent.phoneNumber) && !val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                }
                return true;
            }
        ),
    phoneAreaCode: Yup.string()
        .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
        .length(3, `Must be 3 digits`).test('detailedLocation', 
            function(val) {
                if ((!!this.parent.phoneCountryCode || !!this.parent.phoneNumber) && !val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                }
                return true;
            }
        ),
    phoneNumber: Yup.string()
        .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
        .length(10, `Must be 10 digits`).test('detailedLocation', 
            function(val) {
                if ((!!this.parent.phoneAreaCode || !!this.parent.phoneCountryCode) && !val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                }
                return true;
            }
        ),
    detailedLocationDescription: Yup.string().test('detailedLocationDescription', 
        function(val) {
            if (canAccessHotelDining.value == 'true' && locationToHotel[1].value == FormConst.VALUE_ONSITE 
                && (detailedLocation[1].value == 'Floor' || detailedLocation[1].value == 'Other') && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true;
        }
    ),
    typeOfCuisine: Yup.string().test('typeOfCuisine', 
        function(val) {
            if (canAccessHotelDining.value == 'true' && locationToHotel[1].value == FormConst.VALUE_ONSITE && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true;
        }
    ),
    menuUrl: Yup.string().max(240, 'Max length 240 characters')
        .matches(FormConst.URL_PATTERN, FormConst.VALIDATION_ERROR_URL_FORMAT),
    websiteUrl: Yup.string()
        .max(240, 'Max length 240 characters')
        .matches(FormConst.URL_PATTERN, FormConst.VALIDATION_ERROR_URL_FORMAT),
    email: Yup.string().matches(FormConst.EMAIL_PATTERN, 'Valid email required')
        .max(120, 'Max length 120 characters'),
    invisibleErrorField: Yup.string().test("Any Times Select validation",
        function() {
            if ((locationToHotel[1].value !== FormConst.VALUE_ONSITE) ||
                (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value !== 'true')) {
                return true;
            }

            if (!sameOperatingHours.checked && diningHoursVary.checked) {
                if ((breakfastCheckbox[1] && !breakfastCheckbox[1].checked) &&
                    (brunchCheckbox[1] && !brunchCheckbox[1].checked) &&
                    (lunchCheckbox[1] && !lunchCheckbox[1].checked) &&
                    (happyHourCheckbox[1] && !happyHourCheckbox[1].checked) &&
                    (dinnerCheckbox[1] && !dinnerCheckbox[1].checked)
                ) {
                    return this.createError({ message: "You must select at least one Dining option time slot." })
                }
            }
            return true;
        }
    ),
    detailedOperatingHours: Yup.object({
        dailyDoesntVary: Yup.object({
            hours: Yup.object({
                allDays: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && sameOperatingHours.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && sameOperatingHours.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                })
            })
        }),
        DAILY: Yup.object({
            hours: Yup.object({
                mon: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                tue: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                wed: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                thu: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                fri: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sat: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sun: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && !sameOperatingHours.checked && !diningHoursVary.checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                })
            })
        }),
        BREAKFAST: Yup.object({
            hours: Yup.object({
                mon: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                tue: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                wed: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                thu: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                fri: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sat: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sun: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && breakfastCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                })
            })
        }),
        BRUNCH: Yup.object({
            hours: Yup.object({
                mon: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                tue: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                wed: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                thu: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                fri: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sat: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sun: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && brunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                })
            })
        }),
        LUNCH: Yup.object({
            hours: Yup.object({
                mon: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                tue: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                wed: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                thu: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                fri: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sat: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sun: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && lunchCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                })
            })
        }),
        HAPPY_HOUR: Yup.object({
            hours: Yup.object({
                mon: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                tue: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                wed: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                thu: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                fri: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sat: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sun: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && happyHourCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                })
            })
        }),
        DINNER: Yup.object({
            hours: Yup.object({
                mon: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                tue: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                wed: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                thu: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                fri: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sat: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                }),
                sun: Yup.object({
                    open: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val ) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    ),
                    close: Yup.string().test('Date validation',
                        function(val) {
                            if (locationToHotel[1].value == FormConst.VALUE_ONSITE && canAccessHotelDining.value == 'true' && !this.parent.closed && diningHoursVary.checked && !sameOperatingHours.checked && dinnerCheckbox[1].checked && !val) { return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED }) }
                            else return true;
                        }
                    )
                })
            })
        })
    })
})